var Scinet = Scinet || {};

Scinet.initDatepicker = function () {
    $(".datepicker")
        .removeClass("hasDatepicker")
        .attr("readonly", "readonly")
        .datepicker(
            {
                dateFormat: "d M yy",
                changeMonth: true,
                changeYear: true
            });

    $(".datepicker[data-date]").each(function (index, element) {
        var e = $(element);

        var strDate = e.data("date");
        if (strDate) {
            var date = new Date(strDate);
            e.datepicker("setDate", date);
        }
    });    
}

$(function () {
    Scinet.initDatepicker();
});
